import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/ProductDetailClient.tsx");
